import { render, staticRenderFns } from "./AddWholesaleCompany.vue?vue&type=template&id=594d297a&"
import script from "./AddWholesaleCompany.vue?vue&type=script&lang=js&"
export * from "./AddWholesaleCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/AddWholesaleCompany.vue
// module id = null
// module chunks = 